module.exports = __webpack_public_path__ + "img/15-1.6f61c363.jpg";